import initialState from '../store/initial-state'
import {
  CLIENTS_GET_DATA,
  CLIENTS_GET_DATA_SUCCESS,
  CLIENTS_GET_DATA_FAILURE,
  CLIENTS_EMPTY,
  CLIENTS_TYPE_GET_DATA,
  CLIENTS_TYPE_GET_DATA_SUCCESS,
  CLIENTS_TYPE_GET_DATA_FAILURE,
  CLIENTS_TYPE_BUSINESS_GET_DATA,
  CLIENTS_TYPE_BUSINESS_GET_DATA_SUCCESS,
  CLIENTS_TYPE_BUSINESS_GET_DATA_FAILURE
} from '../constants/client-types'

export default (state = initialState.clients, action) => {
  switch (action.type) {

    case CLIENTS_GET_DATA:
      return {
        ...state,
        isFetching: true,
        data: null,
        headers: null,
        error: null
      }

    case CLIENTS_GET_DATA_SUCCESS:
      return {
        ...state,
        isFetching: false,
        data: action.payload.data,
        headers: action.payload.headers,
        error: null
      }

    case CLIENTS_GET_DATA_FAILURE:
      return {
        ...state,
        isFetching: false,
        data: null,
        headers: null,
        error: action.payload
      }

    case CLIENTS_EMPTY:
      return {
        ...state,
        isFetching: false,
        data: null,
        headers: null,
        error: null
      }
    case CLIENTS_TYPE_GET_DATA_SUCCESS:
      return {
        ...state,
        listTypeClient: action.payload.data
      }

    case CLIENTS_TYPE_GET_DATA_FAILURE:
      return {
        ...state,
        listTypeClient: null,
        error: action.payload
      }
    case CLIENTS_TYPE_GET_DATA:
      return {
        ...state,
        listTypeClient: [],
        error: action.payload
      }

    case CLIENTS_TYPE_BUSINESS_GET_DATA_SUCCESS:
      return {
        ...state,
        listTypeBusinessClient: action.payload.datalist
      }

    case CLIENTS_TYPE_BUSINESS_GET_DATA_FAILURE:
      return {
        ...state,
        listTypeBusinessClient: null,
        error: action.payload
      }
    case CLIENTS_TYPE_BUSINESS_GET_DATA:
      return {
        ...state,
        listTypeBusinessClient: [],
        error: action.payload
      }

    default: return { ...state }
  }
}
